import { PhoneInputOwnProps } from ".";
import "react-phone-input-2/lib/material.css";
import { default as BasePhoneInput } from "react-phone-input-2";
import "./PhoneInput.scss";
import { useTranslation } from "react-i18next";

type PhoneInputProps = PhoneInputOwnProps &
  React.ComponentProps<typeof BasePhoneInput>;

export default function PhoneInput({
  id,
  name,
  error,
  onChange,
  helperText,
  variant,
  ariaRequired,
  ...rest
}: PhoneInputProps & { ariaRequired?: boolean }) {
  const { i18n, t } = useTranslation();

  return (
    <div className={i18n.language === "en" ? "enPhone" : "enPhone arPhone"}>
      <BasePhoneInput
        enableSearch
        searchPlaceholder={String(t("search"))}
        country="sa"
        // localization={i18n.language === "ar" ? ar : {}}
        // inputStyle={{ direction: i18n.language === "en" ? "ltr" : "rtl" }}
        inputProps={{ id, name, "aria-required": ariaRequired || undefined }}
        dropdownClass={"phone-input-dropdown"}
        containerClass={`phone-input ${error ? "phone-input-error" : ""} ${
          variant === "outlined" ? "outlined-label" : ""
        }`}
        onChange={(value, data, e, formattedValue) => {
          onChange?.(value, data, e, formattedValue);
        }}
        {...rest}
      />
      {helperText && <p className="phone-input-helper-text">{helperText}</p>}
    </div>
  );
}
